/**
 * Ermittelt das untere Ende des fixierten Seitenkopfes und veroeffentlicht den
 * Wert als CSS-Variable --site-header-offset, damit sticky Elemente (wie die
 * Shop-Filter-Sidebar oder die Kassen-Bestelluebersicht) unterhalb des Headers
 * andocken koennen, statt darunter zu verschwinden.
 *
 * Gemessen statt fest codiert: Die Hoehe des Headers haengt von Viewport und
 * Template ab, und sein eigenes sticky `top` verschiebt sich mit der Admin-Bar.
 */
export function trackHeaderHeight(): void {
  const header = document.querySelector<HTMLElement>('header.wp-block-template-part');
  if (header === null) return;

  const apply = (): void => {
    const stickyTop = Number.parseFloat(getComputedStyle(header).top);
    const top       = Number.isNaN(stickyTop) ? 0 : stickyTop;
    const offset    = Math.round(top + header.getBoundingClientRect().height);

    document.documentElement.style.setProperty('--site-header-offset', `${offset}px`);
  };

  apply();

  window.addEventListener('resize', apply);
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(apply).observe(header);
  }
}
